/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack(params, context) {
    // 驿站掌柜：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html
    context.WVCall('WVNavUrls.pop', params);
}

export { navigateBack as default };
